import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { HelperTextOutside } from './TextField/HelperTextOutside'
import clsx from 'clsx'

export default class TextAreaInput extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    stateSetter: PropTypes.func.isRequired,
    limit: PropTypes.number,
    showMaxLength: PropTypes.bool,
    showLabelOptional: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.string
  }

  onChange = (event) => {
    this.props.stateSetter(this.props.name, event.target.value)
  }
  
  shouldComponentUpdate({ value, disabled, showLabelOptional, error }) {
    return this.props.value !== value || this.props.disabled !== disabled || this.props.showLabelOptional !== showLabelOptional || this.props.error !== error
  }

  render() {
    const { name, label, disabled, showLabelOptional, showMaxLength, error, changeStateModal, ...restOfProps } = this.props
    const className = disabled ? 'form-control disabled' : clsx('form-control', { 'error-state': error })

    return (
      <div className={changeStateModal ? "common-text-area-input-modal" : "common-text-area-input" } id={restOfProps.id}>
        {
          label && 
          <label htmlFor={name} className="text-label">{label}</label>
        }
        {showLabelOptional && (
            <span className="text-optional">{` (opcional)`}</span>
        )}
        <textarea
          {...restOfProps}
          name={name || restOfProps.id}
          className={changeStateModal ? `text-area ${className}` : className }
          disabled={disabled}
          onChange={this.props.onChange || this.onChange}
          maxLength={this.props.limit}
        />
        {error && (
            <HelperTextOutside size='small' error helperText={error} />
        )}
        {
          showMaxLength &&
            <span className="text-maxlength">
              {`${this.props.value.length} / ${this.props.limit}`}
            </span>
        }
      </div>
    )
  }
}
